export const ListBlessed = ({ record }) => {
  return record.fastTrackReferrals ? <span style={{ paddingLeft: '2ch' }}>✔️</span> : '';
};
